<template>
  <Stepper
    :stepperSteps="stepperSteps"
    @completed-step="completeStep"
    @active-step="isStepActive"
    :showNavigation="false"
    @closeModal="closeModal"
  />
</template>
<script>
  import { Stepper } from "@/components/commons";
  import {
    EditDetails,
    AccountInfo,
    ModuleSelection,
    DurationTerms,
    Pricing,
    EditSummary
  } from "../business-stepper-component";
  export default {
    name: "Edit-Business-Partner-Step",
    components: { Stepper },
    props: {
      detailsId:{
        type: String,
        default: '',
      },
    },
    data() {
      return { 
        stepperSteps: [
          {
            stepIcon: "briefcase",
            stepTitle: "Business Details",
            stepSequence: "first",
            stepComponent: EditDetails,
            isCompleted: true,
            detailsId: this.detailsId
          },
          {
            stepIcon: "user",
            stepTitle: "Admin Account Details",
            stepSequence: "second",
            stepComponent: AccountInfo,
            isCompleted: false,
          },
          {
            stepIcon: "check",
            stepTitle: "Module Selection",
            stepSequence: "third",
            stepComponent: ModuleSelection,
            isCompleted: false,
            detailsId: this.detailsId
          },
          {
            stepIcon: "calendar",
            stepTitle: "Duration Terms",
            stepSequence: "fourth",
            stepComponent: DurationTerms,
            isCompleted: false,
            detailsId: this.detailsId
          },
          {
            stepIcon: "dollar-sign",
            stepTitle: "Pricing",
            stepSequence: "fifth",
            stepComponent: Pricing,
            isCompleted: false,
            detailsId: this.detailsId
          },
          {
            stepIcon: "file",
            stepTitle: "Contract Summary",
            stepSequence: "sixth",
            stepComponent: EditSummary,
            isCompleted: false,
            detailsId: this.detailsId
          }
        ],
        activeStep: 0,
      };
    },
    methods: {
      completeStep(payload) {
        this.stepperSteps.forEach((step) => {
          if (step.stepSequence === payload.stepSequence) {
            step.isCompleted = true;
          }
        });
      },
      isStepActive(payload) {
        this.stepperSteps.forEach((step) => {
          if (step.stepSequence === payload.stepSequence) {
            if (step.isCompleted === true) {
              step.isCompleted = false;
            }
          }
        });
      },
      closeModal(){ 
              console.log('submitSuccess');

        this.$emit('closeModal')
        this.$emit('submitSuccess')
      }
    },
  };
</script>
